//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
//@end

//@import components
import CapsuleItemSkeleton from 'app_components/screens/landing/capsuleitem/components/capsuleItemSkeleton';
import PublicAppContainer from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import ContentNewsCommon from 'app_components/commons/contentnews'
import SeparatorHorCommon from 'app_components/commons/separatorhor'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
//@end

// @import hooks
// @end

// @INFO Import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import '../capsuleitemScreen.scss'

// @ADD Component types
interface ICapsuleitemScreenLayoutProps {
  post: IPost | null
  loading: boolean
}

const CapsuleitemScreenLayout: React.FC<ICapsuleitemScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppContainer>
      <BannerTextPrimaryCommon text={'Capsulas'}/>

      <div className={'capsule_item-component mb-4'}>
        <Container >
          <Row className="mb-4">
            <Col xs={12} md={12}>
              {props.loading ? (
                <CapsuleItemSkeleton />
              ) : (
                <>
                  {props.post ? (
                    <ContentNewsCommon news={props.post}/>
                  ) : (
                    <div className="mt-3">
                      <AlertComponent
                        type='warning'
                        title={t('screens.capsule.no_data')}
                      />
                    </div>
                  )}
                </>
              )}
            </Col>

          </Row>

          <SeparatorHorCommon/>
        </Container>
      </div>
    </PublicAppContainer>
  )
}

export default CapsuleitemScreenLayout
